"use client";

import { useEffect, useState } from "react";

const UniqueCookieRef = () => {
  const [uniqueCookieReference, setUniqueCookieReference] = useState("");

  useEffect(() => {
    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("AOCookieRequestReference="))
      ?.split("=")[1];

    if (!cookie) return;

    setUniqueCookieReference(cookie);
  }, []);

  return (
    <p className="text-gray-70 text-xs cookie-reference leading-[1.425rem]">
      Unique Cookies Reference: <br className="" />
      <span>{uniqueCookieReference}</span>
    </p>
  );
};

export default UniqueCookieRef;
